<script setup lang="ts">
definePage({
  name: 'quotation-comments',
  meta: {
    title: '报价评论',
  },
})

const lickVal = ref('')

function onLickSet(val: string = '') {
  lickVal.value = val
}
</script>

<template>
  <FmPageLayout navbar back :search="false" class="p-10px">
    <div class="h-93px flex items-center gap-6px rounded-5px bg-[#fff] p-10px">
      <FmIcon v-if="lickVal === '1'" name="src/assets/images/like-active.png" class="text-29px" @click="onLickSet('')" />
      <FmIcon v-else name="src/assets/images/like.png" class="text-29px" @click="onLickSet('1')" />
      <div class="flex flex-1 items-center gap-5px">
        <div class="relative h-20px w-[50%] rounded-10px" style="background: linear-gradient(270deg, #ff9f00 0%, #f60 100%);">
          <div class="absolute left-0px top-[-15px] text-9px color-[#333]">
            {{ lickVal === '1' ? '1' : '0' }}%
          </div>
          <div class="absolute bottom-[-15px] left-0px text-9px color-[#333]">
            {{ lickVal === '1' ? '1' : '0' }}人
          </div>
        </div>
        <div class="relative h-20px w-[50%] rounded-10px" style="background: linear-gradient(90deg, #2bb7fc 0%, #3c78ff 100%);">
          <div class="absolute right-0px top-[-15px] text-9px color-[#333]">
            {{ lickVal === '0' ? '1' : '0' }}%
          </div>
          <div class="absolute bottom-[-15px] right-0px text-9px color-[#333]">
            {{ lickVal === '0' ? '1' : '0' }}人
          </div>
        </div>
      </div>
      <FmIcon v-if="lickVal === '0'" name="src/assets/images/oppose-active.png" class="text-29px" @click="onLickSet('')" />
      <FmIcon v-else name="src/assets/images/oppose.png" class="text-29px" @click="onLickSet('0')" />
    </div>
    <div class="m-t-10px text-13px font-500 line-height-35px" style="border-bottom: 1px solid #e4e5e9;">
      精彩评论（1）
    </div>

    <div class="flex items-center gap-10px p-b-10px p-t-10px">
      <FmIcon name="carbon:user-avatar-filled-alt" class="text-40px color-[#999]" />
      <div class="flex-1 text-11px">
        <div class="flex items-center justify-between">
          <span>用户887564</span>
          <span class="flex items-center">
            <FmIcon name="ic:outline-favorite-border" class="text16px m-r-5px color-[#E51A2D]" />
            <span>1</span>
          </span>
        </div>
        <div class="text-7px color-[#999]">
          刚刚
        </div>
        <div class="m-t-4px">
          我在价位(42000.0)看多沪港通南向
        </div>
      </div>
    </div>

    <div class="fixed bottom-0px left-0px w-100% flex gap-10px bg-[#fff] p-b-15px p-l-7px p-r-7px p-t-15px">
      <div class="flex flex-1 items-center overflow-hidden rounded-7px bg-[#FAF8F9] p-l-7px" style="border: 1px solid #eee;">
        <FmIcon name="mdi:lead-pencil" class="m-r-5px text-16px color-[#999]" />
        <input type="text" class="h-32px flex-1 bg-[#FAF8F9]">
      </div>
      <van-button class="w-60px" type="primary" round size="small">
        发送
      </van-button>
    </div>
  </FmPageLayout>
</template>
